import React from 'react';
import Checkbox from '../common/components/Checkbox';
import {PERMISSIONS} from '../../constants/permission';

interface permissionProps {
    selectedPermission: string[],
    userRoleId: string,
    disableCheck?: boolean,
    onClick: (checked: boolean, permission: string) => void,
}

function Permission(props: permissionProps) {
    const {selectedPermission, userRoleId, disableCheck, onClick} = props;

    const defaultPermission = Object.keys(PERMISSIONS).map((permission) => {
        return PERMISSIONS[permission]
    });

    const handleSelected = (value: string) => {
        const index = selectedPermission.findIndex(
            (permission) => permission === value);
        return index > -1 ? true : false;
    };

    return (
        <div className='d-flex align-items-center gap-1 user-permission-container'>
            {defaultPermission.map((value) => {
                return (
                    <div className='d-flex align-items-center gap-1 user-permission-item' key={`permission-id-${value}-${userRoleId}`}>
                        <Checkbox
                            onClick={(checked) => onClick(checked, value)}
                            selected={handleSelected(value)}
                            disable={
                                value === PERMISSIONS.R ||
                                disableCheck ? true : false}
                        />
                        <span>{value}</span>
                    </div>
                );
            })}
        </div>
    );
}

export default Permission;
